import { render, staticRenderFns } from "./HomeJournal.vue?vue&type=template&id=57057798"
import script from "./HomeJournal.vue?vue&type=script&lang=js"
export * from "./HomeJournal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports